import { useLoftTool, useSweepTool, useRevolveTool, useExtrudeTool, useBooleanTool } from '../tools/nurbs';
import { useTool } from '../state/store';
import { useEntityClickListener } from './toolEventBus';

/**
 * NURBS selection tools bridge (Phase 2, task 2.4).
 *
 * The NURBS command tools (loft/sweep/revolve/extrude/boolean) react to
 * entity clicks instead of pointer drawing. Only the bridge of the ACTIVE
 * tool mounts and subscribes its entity-click listener; the hooks are no
 * longer permanently instantiated by SceneContent.
 */
export function NurbsSelectionBridge() {
    const tool = useTool();

    if (tool === 'loft') return <LoftBridge />;
    if (tool === 'sweep') return <SweepBridge />;
    if (tool === 'revolve') return <RevolveBridge />;
    if (tool === 'extrude') return <ExtrudeBridge />;
    if (tool.startsWith('boolean')) return <BooleanBridge />;

    return null;
}

function LoftBridge() {
    const tool = useLoftTool();
    useEntityClickListener((entityId) => tool.addCurveToLoft(entityId), [tool]);
    return null;
}

function SweepBridge() {
    const tool = useSweepTool();
    useEntityClickListener((entityId) => tool.selectCurve(entityId), [tool]);
    return null;
}

function RevolveBridge() {
    const tool = useRevolveTool();
    useEntityClickListener((entityId) => tool.selectProfile(entityId), [tool]);
    return null;
}

function ExtrudeBridge() {
    const tool = useExtrudeTool();
    useEntityClickListener((entityId) => tool.selectProfile(entityId), [tool]);
    return null;
}

function BooleanBridge() {
    const tool = useBooleanTool();
    useEntityClickListener((entityId) => tool.selectSolid(entityId), [tool]);
    return null;
}
